import { change, destroy, reset } from 'redux-form';

import { INFERENTIAL_STATISTICS as FORM } from '../names';
import { round6AndFormatValue } from 'utilities/math';

// Setters

export const setSampleMean = sampleMean =>
  change(FORM, 'oneSampleT.sampleMean', sampleMean);

export const setStandardDeviation = standardDeviation =>
  change(FORM, 'oneSampleT.standardDeviation', standardDeviation);

export const setSampleSize = sampleSize =>
  change(FORM, 'oneSampleT.sampleSize', sampleSize);

export const setNumberOfSuccess = numberOfSuccess =>
  change(FORM, 'oneSampleProportion.numberOfSuccess', numberOfSuccess);

export const setNumberOfTrials = numberOfTrials =>
  change(FORM, 'oneSampleProportion.numberOfTrials', numberOfTrials);

export const setMeansOneSampleT = ({
  count, mean, sampleStandardDeviation
}) => dispatch => {
  dispatch([
    setSampleSize(count),
    setSampleMean(round6AndFormatValue(mean)),
    setStandardDeviation(
      round6AndFormatValue(sampleStandardDeviation)
    )
  ]);
};

export const setNumericalRowDataSet = rowDataSet =>
  change(FORM, 'oneSampleT.numericalRowDataSet', rowDataSet);

export const setCategoricalRowDataSet = categoricalRowDataSet =>
  change(FORM, 'oneSampleProportion.categoricalRowDataSet', categoricalRowDataSet);

export const setLevelsRowDataSet = levelsRowDataSet =>
  change(FORM, 'oneSampleProportion.levelsRowDataSet', levelsRowDataSet);

// Reset: Set Form Fields value to Initial Value
// Example: UI action to Reset Form Values
export const resetInferentialStatistics = () => reset(FORM);

// Destroy: Deleted dynamically create Form Fields from Forl
// Example: Dynamic fields are generated based on frequency categories,
// We need to delete those fields when we change dataset
export const destroyInferentialStatistics = () => destroy(FORM);
